import script from "./ListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ListPage.vue?vue&type=script&setup=true&lang=js"

import "./ListPage.vue?vue&type=style&index=0&id=1cc8c1be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc8c1be"]])

export default __exports__